import React, { Component } from "react";

class CreateClientBtn extends Component {
  render() {
    return (
      <React.Fragment>

        <div className="wrapper">
          <header className="header">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="logo">
                    <a><img src="/assets/images/logo.png" alt="" /></a>
                  </div>
                </div>
                <div className="col">
                  <div className="headerRight">
                    <div className="searchBlock">
                      <input className="form-control" placeholder="Search" type="text" name="" />
                      <button className="searcIcon sprite" type="button"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div className="container">
            <div className="blankListBox">
              <h1>You don't have any client create new</h1>
              <a className="blueBtn" href="create-client.html">Create Client</a>
            </div>

          </div>
        </div>

      </React.Fragment>
    )
  }
}

export default CreateClientBtn;
